import {
  profileData,
  softwareProficiency,
  programmingLanguages,
} from "../data/profileData.js";
import AnimatedBackground from "../components/AnimatedBackground.js";
import "../styles.css";

export function AboutTab() {
  return (
    <>
      <AnimatedBackground />
      <div className="page-section" style={{ position: "relative", zIndex: 1 }}>
        {/* Hero Section */}
        <section className="hero-section">
          <img
            src={profileData.profileImage}
            alt={profileData.name}
            className="profile-image"
          />
          <div className="profile-info">
            <h1 className="profile-name">{profileData.name}</h1>
            <p className="profile-title">{profileData.title}</p>
            <p className="profile-bio">{profileData.bio}</p>
            <div className="action-buttons">
              <a href={`mailto:${profileData.email}`} className="btn-primary">
                Email Me
              </a>
              <a
                href={profileData.github}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-secondary"
              >
                GitHub
              </a>
              <a
                href={profileData.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-secondary"
              >
                LinkedIn
              </a>
            </div>
          </div>
        </section>

        {/* Skills Section */}
        <section className="page-section">
          <div className="skills-grid">
            {/* Software Proficiency */}
            <div className="skill-blocks">
              <h3 className="skill-category-title">Software Proficiency</h3>
              <div className="skill-items-grid">
                {softwareProficiency.map((software) => (
                  <div key={software.name} className="skill-card">
                    <img
                      className="skill-icon"
                      src={software.icon}
                      alt={software.name}
                      width={60}
                    />
                    <p className="skill-name">{software.name}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Programming Languages */}
            <div className="skill-blocks">
              <h3 className="skill-category-title">Programing Languages</h3>
              <div className="skill-items-grid">
                {programmingLanguages.map((language) => (
                  <div key={language.name} className="skill-card">
                    <img
                      className="skill-icon"
                      src={language.icon}
                      alt={language.name}
                      width={60}
                    />
                    <p className="skill-name">{language.name}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
